import { forwardRef } from 'react';
import { cn } from '@/lib/utils.js';

/**
 * Multi-line text input — matches Input's styling vocabulary so they sit
 * cleanly next to each other on the same form. Defaults to a 4-row height;
 * pass `rows` to override. Use `font-mono` from the caller if the content
 * is code (command templates, paramSchema JSON).
 */
export const Textarea = forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, rows = 4, ...props }, ref) => (
    <textarea
      ref={ref}
      rows={rows}
      className={cn(
        'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm shadow-sm ' +
          'placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 ' +
          'focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';
